<template>
  <div class="p-4">
    <validation-observer ref="statusForm">
      <validation-provider rules="required" v-slot="{ errors }">
        <div class="color-primary-4 font-14 font-weight-bold mb-1">
          {{ $t('ChangeOfStatus') }}:
        </div>
        <custom-drop-down
          v-if="!model.solicitanteMode"
          v-model="model.status"
          fieldkey="id"
          fieldname="name"
          class="case-info__dropdown"
          :placeholder="$i18n.t('ddlNewStatus.Text')"
          :options="statusList"
          :disabled="isCaseResolved"
          :error="errors[0]"
          :custom-error-msg="$i18n.t('valreqDdlNewstatus.Text')"
          @input="onChangeStatusHandler"
        />
      </validation-provider>

      <div v-if="showDocuments || model.solicitanteMode" class="mt-4">
        <documents
          ref="documentRef"
          :item-id="itemId"
          :documents="documentMappedList"
          @on-refresh-document="onRefreshHandler"
        />
      </div>
    </validation-observer>
    <div v-if="!isCaseResolved" class="mt-3">
      <action-button
        :text="$t('btCancel.Text')"
        class="warning outline-warning px-4 py-2 mr-2"
        i="fal fa-times-circle"
        @click="onCancelHandler"
      />
      <action-button
        :text="$t('btnSaveSC')"
        class="btn-success px-4 py-2"
        i="fal fa-check-circle"
        :disabled="isSaving"
        @click="onSaveHandler"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import roles from '@/utils/constants/roles.js';
import {
  getAvailableStatus as _getAvailableStatus,
  saveStatusChange as _saveStatusChange,
  getWorkflowStatusList as _getWorkflowStatusList,
  startTimeStampProccess as _startTimeStampProccess,
} from '@/modules/tickets/api.js';
import {
  getDocumentValidation as _getDocumentValidation,
  validateAuthorizationLetter as _validateAuthorizationLetter,
} from '@/services/app.api.js';
import { getAuthorizationLetterReport as _getAuthorizationLetterReport } from '@/services/report.api.js';
import langTypes from '@/utils/constants/lang.js';
import alertMixin from 'utils/mixins/alert.mixin';
import caseNotifyType from '@/utils/constants/caseNotifyType.js';
import caseStatus from '@/utils/constants/caseStatus.js';
import requestStatus from '@/utils/constants/requestStatus.js';
import Documents from '@/views/request/components/Documents.vue';
import {
  authorizationLetterMessages,
  getAuthorizationLetterValidationError,
} from '@/views/request/utils/authorizationLetterValidation';

import { name as userModuleName } from '@/store/modules/user';
import { i18n } from '@/i18n';

export default {
  name: 'ChangeStatus',
  mixins: [alertMixin],
  components: {
    CustomDropDown,
    ActionButton,
    Documents,
  },
  data() {
    return {
      statusList: [],
      document: {
        documentUploaded: null,
        requiredDocumentCategories: null,
      },
      isSaving: false,
      model: {
        solicitanteMode: false,
        status: null,
        viewAll: null,
      },
    };
  },
  computed: {
    isEnLang() {
      return this.userSelectedLang === langTypes.EN;
    },
    isPendingInfoSelected() {
      return this.model?.status?.id === caseStatus.PendienteInformacion;
    },
    isCancelSelected() {
      return this.model?.status?.id === caseStatus.Cancelado;
    },
    showDocuments() {
      return (
        this.model?.status?.id === requestStatus.DocumentoTesis ||
        this.model?.status?.id === requestStatus.DocumentoCarta
      );
    },
    businessId() {
      return this.itemModel?.requestNumber;
    },
    itemId() {
      return this.itemModel?.itemId;
    },
    documentMappedList() {
      if (this.document === undefined) return [];

      const requiredDocumentCategories =
        this.document.requiredDocumentCategories ?? [];
      const documentUploaded = this.document.documentUploaded ?? [];

      var documentCategories = requiredDocumentCategories.map((item) => {
        const document1 = documentUploaded.find(
          (d) => d.documentCategoryId === item.documentCategoryId
        );
        return {
          id: item.documentCategoryId,
          documentCategoryName: item.documentCategoryName,
          documentId: document1?.documentId,
          filename: document1?.filename,
          isPublic: document1?.isPublic,
        };
      });

      var result = documentCategories;
      return result;
    },
  },
  async mounted() {
    if (this.businessId) {
      await this.callGetStatusList(this.businessId);
      console.log(this.model);
    }
    this.model.solicitanteMode =
      this.roleName()?.toLowerCase() === roles.APPLICANT.toLowerCase();
    if (this.model.solicitanteMode) {
      console.log('modelstatus');
      console.log(this.roleName);
      console.log(this.statusList);
      this.onChangeStatusHandler(this.statusList[0]);
    }
  },
  methods: {
    ...mapGetters(userModuleName, {
      roleName: 'role',
    }),
    async callGetStatusList(businessId) {
      const { data } = await _getAvailableStatus(businessId, this.isEnLang);
      this.statusList = data;
    },
    async callGetWorkflowStatusList(businessId) {
      const { data } = await _getWorkflowStatusList(businessId);
      this.statusList = data;
    },
    onCancelHandler() {
      this.setIsNavOpen({
        isNavOpen: false,
        navOption: {},
      });
    },
    async onSaveHandler() {
      if (this.isSaving) return;

      const valid = await this.validate();
      if (!valid) return;

      const { id: statusId, name: statusName } = this.model.status;
      const comment = this.model.comment;
      const { itemId, requestNumber } = this.itemModel;
      console.log(statusName);

      if (statusId && itemId && requestNumber) {
        const answer = await this.ShowCancelModal(
          'Cambiar Estatus',
          '¿Está seguro que desea cambiar el estatus?',
          'Si',
          'No'
        );
        if (!answer) return;

        this.isSaving = true;
        try {
          let letterValidation = null;
          if (
            statusId == requestStatus.Autorizado ||
            statusId == requestStatus.DocumentoTesis
          ) {
            letterValidation = await this.validateAuthorizationLetter(
              requestNumber,
              statusId
            );

            if (!letterValidation) {
              this.isSaving = false;
              return;
            }
          }

          await _saveStatusChange(
            requestNumber,
            itemId,
            statusId,
            statusName,
            comment
          );

          if (statusId == requestStatus.Autorizado) {
            if (!letterValidation.documentExists) {
              await _getAuthorizationLetterReport(requestNumber);
            }
            await _startTimeStampProccess(itemId);
          }

          this.ShowToast(
            'Proceso exitoso',
            'El estatus ha sido cambiado exitosamente.',
            'success'
          );

          this.setRefreshCaseInfo({
            lastNotify: new Date(),
            lastNotifyType: caseNotifyType.REFRESH_CASE_INFO,
          });

          await this.callGetStatusList(this.businessId);
          await this.$refs.statusForm.reset();
          this.model = {};
          this.onCancelHandler();
        } catch (error) {
          this.ShowToast(
            'Error',
            error?.response?.data?.message ||
              'Ha ocurrido un error inesperado.',
            'error'
          );
        } finally {
          this.isSaving = false;
        }
      }
    },
    async validateAuthorizationLetter(requestNumber, statusId) {
      const { data: validation } = await _validateAuthorizationLetter(
        requestNumber
      );

      const validationError = getAuthorizationLetterValidationError(
        validation,
        statusId
      );

      if (!validationError) {
        return validation;
      }

      if (validationError === authorizationLetterMessages.letterNotExists) {
        this.ShowToast(
          this.$t('authorizationLetter.validationTitle'),
          this.$t('authorizationLetter.letterNotExists'),
          'error'
        );
        return null;
      }

      if (
        validationError === authorizationLetterMessages.documentMissingForThesis
      ) {
        this.ShowToast(
          this.$t('authorizationLetter.validationTitle'),
          'Debe generar la carta de autorización antes de mover la solicitud a Documento de Tesis.',
          'error'
        );
        return null;
      }

      if (
        validationError ===
        authorizationLetterMessages.documentNotStampedForThesis
      ) {
        this.ShowToast(
          this.$t('authorizationLetter.validationTitle'),
          'La carta de autorización debe estar ponchada antes de mover la solicitud a Documento de Tesis.',
          'error'
        );
        return null;
      }
    },
    async onChangeStatusHandler(value) {
      if (value?.id === undefined) return;

      var data = (await _getDocumentValidation(this.businessId, value?.id))
        .data;

      this.document.documentUploaded = data.documents;
      this.document.requiredDocumentCategories =
        data.requiredDocumentCategories;
    },
    async onRefreshHandler() {
      var data = (
        await _getDocumentValidation(this.businessId, this.model.status?.id)
      ).data;

      this.document.documentUploaded = data.documents;
      this.document.requiredDocumentCategories =
        data.requiredDocumentCategories;
    },
    async validate() {
      let hasAllDocuments = true;
      if (this.$refs.documentRef?.documents.length) {
        hasAllDocuments = this.$refs.documentRef?.documents.every(
          (x) => x.documentId
        );
      }

      if (!hasAllDocuments) {
        this.ShowToast('', i18n.t('StatusChange-DocumentsError'), 'error');
      }

      return (await this.$refs.statusForm.validate()) && hasAllDocuments;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';

::v-deep button[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
